export const Appointment = () => import('./appointment/Main.vue');
export const OnePartA = () => import('./one-part-a/Main.vue');
export const OnePartB = () => import('./one-part-b/Main.vue');
export const Two = () => import('./two/Main.vue');
export const ThreeToFour = () => import('./three-to-four/Main.vue');
export const Five = () => import('./five/Main.vue');
export const Six = () => import('./six/Main.vue');
export const Seven = () => import('./seven/Main.vue');
export const Eight = () => import('./eight/Main.vue');
export const Nine = () => import('./nine/Main.vue');
export const Ten = () => import('./ten/Main.vue');
export const Signature = () => import('./signature/Main.vue');
